import "./index.scss";

import { Avatar, Box, Stack } from "@mui/material";
import { ReactComponent as UncheckedCircleIcon } from "assets/images/toggle-checkboxes/circle/off-normal.svg";
import { ReactComponent as CheckedCircleIcon } from "assets/images/toggle-checkboxes/circle/on-normal.svg";
import { stringAvatar } from "helpers/utils";
import React, { memo } from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  name?: string;
  hasImage?: boolean;
  image?: string;
}

const CheckableButtonComponent = (props: Props) => {
  const { active, name = "", hasImage, image, ...restProps } = props;

  return (
    <button className={`checkable-button ${active ? "active" : ""}`} {...restProps}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" className="info" justifyContent="flex-start">
          {hasImage ? (
            <div className="icon">
              <Avatar src={image} className="checkable-avatar" {...stringAvatar(name)} />
            </div>
          ) : null}
          <Box pl={!hasImage ? "16px" : 0}>
            <h3>{name}</h3>
          </Box>
        </Stack>
        <div className="check">{active ? <CheckedCircleIcon /> : <UncheckedCircleIcon />}</div>
      </Stack>
    </button>
  );
};

const CheckableButton = memo(CheckableButtonComponent);
export default CheckableButton;
